import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectTagQueryItems } from '../../../../../../redux/tags/selector';
import { tags } from '../../../../../../redux/tags/action';
import TagComponent from '../components/tag.component';
import PageLoader from '../../../../../../components/PageLoader';
import { deepCopy } from '../../../../../../common/services/common.service';
let currentChange: any = {}
const ManagementTagSettings = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const tagSettingsQuery = useSelector(selectTagQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedTag, setSelectedTag] = useState<any>([])
  const [
    tagValues,
    setTagValues
  ] = useState<any>([])
  const fetchTagById = () => {
    dispatch(tags.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/query`,
      entity: 'tags',
      jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTag({ ...selectedTag, [field]: event });
  }

  useEffect(
    () => {

      if (parmas?.id > 0) {
        fetchTagById()
        setIsLoading(false)
      }
      const localSelectedKeywords = addNewTagValuesRow({ selectedKeywordsArg: tagValues });
      setTagValues(localSelectedKeywords)
      setIsLoading(false)
    },
    []
  )

  useEffect(
    () => {

      if (isQuery) {
        setSelectedTag(tagSettingsQuery?.result?.items)
        const localSelectedKeywords = addNewTagValuesRow({ selectedKeywordsArg: tagSettingsQuery?.result?.items?.TagValues });
        setTagValues(localSelectedKeywords)
      }
    },
    [isQuery]
  )


  const addNewTagValuesRow = ({ selectedKeywordsArg }: any) => {
    const localSelectedKeywords = deepCopy(selectedKeywordsArg)
    const newTagValues = {
      TagNameId: 0,
      Value: ''

    }
    if (localSelectedKeywords.length === 0 ||
      localSelectedKeywords[localSelectedKeywords?.length - 1]?.Value !== ''
    ) {
      localSelectedKeywords?.push(newTagValues)
    }

    return localSelectedKeywords
  }

  const handleFormKeywordItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(tagValues);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setTagValues(items);
  }

  const setCombinationKeywordInfo = async () => {
    let localSelectedKeyword = deepCopy(tagValues)
    localSelectedKeyword.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeyword[currentChange.idx] }
    );
    localSelectedKeyword = addNewTagValuesRow({ selectedKeywordsArg: localSelectedKeyword });
    currentChange.field = 'ValueD1'
    setTagValues(localSelectedKeyword)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Value') {
        setCombinationKeywordInfo()
      }
    },
    [tagValues]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    tagValues.splice(
      tagValues.length - 1,
      1
    )
 const tagData={
  Name: selectedTag?.Name,
  TagValues:tagValues
 }
 console.log(tagData,'gvvgvh')
    if (parmas?.id > 0) {
      await dispatch(tags.resetAction({ actionType: 'update' }))
      await dispatch(tags.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags`,
        entity: 'tags',
        jsonData: {
          Records: [
            tagData
          ]
        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(tags.resetAction({ actionType: 'create' }))
      await dispatch(tags.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags`,
        entity: 'tags',
        jsonData: {
          Records: [
            tagData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/settings/global-settings/tags')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <TagComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedTag={selectedTag}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleFormKeywordItemChange={handleFormKeywordItemChange}
          tagValues={tagValues}
        />
      }
    </>
  )
}

export default ManagementTagSettings;